import { render } from "./ButtonDomAdd.vue?vue&type=template&id=479bed2d"
import script from "./ButtonDomAdd.vue?vue&type=script&lang=js"
export * from "./ButtonDomAdd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__